var _nodeUtil = {exports: {}};

export { _nodeUtil as __module };
